// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};



/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_is-integer.js
 **/